import React from "react";

import './_settings.scss'
import {Breadcrumb, BreadcrumbItem, Column, Grid} from "@carbon/react";
import {Link} from "react-router-dom";

const Settings = () => {
  return (
    <Grid fullWidth className="alarms-page">
      <Column lg={16} md={8} sm={4} >
        <Grid className="page-banner">
          <Column lg={16} md={4} sm={4}>
            <Breadcrumb noTrailingSlash aria-label="Page navigation">
              <BreadcrumbItem>
                <Link to='/'>Home</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                Sistema
              </BreadcrumbItem>
              <BreadcrumbItem>
                Impostazioni
              </BreadcrumbItem>
            </Breadcrumb>
          </Column>
          <Column lg={16} md={4} sm={4}>
            <h1 className="page-heading">
              Impostazioni
            </h1>
          </Column>
        </Grid>
      </Column>
    </Grid>
  )
}

export default Settings